import React from "react";
import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/theme-tomorrow";
import "ace-builds/src-min-noconflict/ext-searchbox";
import "ace-builds/src-min-noconflict/ext-language_tools";
import _ from "lodash";
import cx from "classnames";
import styles from "./externalScriptEditorView.module.scss";
import { localizedStrings } from 'src/localization/index.jsx';

class ExternalScriptEditorView extends React.Component {
  constructor(props) {
    super(props);
    const integration = this.props.integration;

    this.state = {
      script: (integration && integration.configuration.script) || "",
      errors: {},
    };

    this._handleSaveClick = this._handleSaveClick.bind(this);
    this._handleCancelClick = this._handleCancelClick.bind(this);

    this.localizedIntegrations = localizedStrings.components.integrations;
    this.localizedCommons = localizedStrings.commons;
    this.localizedExternalScripts = localizedStrings.components.integrations.external_scripts;
  }

  _validateForm() {
    var errors = {};
    if (!this.state.script || this.state.script.trim() == "") {
      errors["script"] = this.localizedExternalScripts.error_message;
    }

    return errors;
  }

  _handleSaveClick(source) {
    let errors = this._validateForm();

    this.setState({
      errors: errors,
    });

    if (Object.keys(errors).length > 0) {
      return;
    }

    let configuration = {
      script: this.state.script,
    };
    this.props.activateAccount(configuration)
    .then((response) => {
      if (response.type === "external_script" && source === "activate") {
        this.props.trackAdoptionMetricsForPluginConnectedEvent('External Script');
      }
    })
    .catch(error => {
      console.error("Error activating account:", error);
    });
  }

  _handleCancelClick() {
    this.setState({
      script: this.props.integration.configuration.script,
    });
  }

  render() {
    return (
      <div className={styles.content}>
        <h1>{ this.localizedExternalScripts.editor }</h1>
        <p className={styles.errorMessage}>{this.state.errors.script}</p>

        <AceEditor
          className={styles.aceEditor}
          mode={"javascript"}
          width="100%"
          theme="tomorrow"
          fontSize={14}
          showPrintMargin={true}
          showGutter={true}
          highlightActiveLine={true}
          value={this.state.script || ""}
          onChange={(value) => {
            this.setState((state) => {
              state.script = value;
            });
          }}
          setOptions={{
            useWorker: false,
            enableBasicAutocompletion: true,
            enableLiveAutocompletion: true,
            enableSnippets: false,
            showLineNumbers: true,
            tabSize: 2,
          }}
        />

        {!this.props.integration && (
          <div className={styles.alignment}>
            <button onClick={() => {
                  this._handleSaveClick("activate")
                }}
                className={styles.button}>
              {this.props.activating &&  `${this.localizedIntegrations.actions.activating}...`}
              {!this.props.activating &&  this.localizedIntegrations.actions.activate }
            </button>
          </div>
        )}
        {this.props.integration && (
          <div className={styles.alignment}>
            <button onClick={() => {
                  this._handleSaveClick("save_changes")
                }}
                 className={styles.button}>
              {this.props.activating && `${this.localizedCommons.actions.saving_changes}...`}
              {!this.props.activating && this.localizedCommons.actions.save}
            </button>
            <button
              onClick={this._handleCancelClick}
              className={cx(styles.button, styles.cancel)}
            >
              {this.localizedCommons.actions.cancel}
            </button>
          </div>
        )}
      </div>
    );
  }
}

export default ExternalScriptEditorView;
